import React, { Component } from 'react';
import { Grid, Cell, ProgressBar } from 'react-mdl';

class Skills extends Component {
  render() {
    return(
      <Grid>
        <Cell col={12}>
          <button style={{display: 'flex', color:'red',fontWeight:'bold' }}>{this.props.skill} </button>
        </Cell>
      </Grid>
    )
  }
}

export default Skills;